import classNames from 'classnames';
import type { FC } from 'react';
import React from 'react';

import { headlineContentService, MAX_STEPS_SERVICE } from '../forms/service/constants';
import useAppStore, { SERVICE_CARD } from '../service/store/app';
import { scrollToRef } from '../utils/scroll';

import './Headlines.scss';
import Icon from './ui/Icon';

export interface IHeadlineContent {
  title: string;
  lead: string;
  back?: string;
}

interface IHeadlinesProps {
  title?: string;
  lead?: string;
  back?: string;
  headlines?: IHeadlineContent[];
  maxSteps?: number;
  reset?: () => void;
  setStep: (step: number) => void;
  step: number;
}

const Headlines: FC<IHeadlinesProps> = ({
  reset,
  headlines = headlineContentService,
  maxSteps = MAX_STEPS_SERVICE,
  step,
  setStep
}) => {
  const selectedServiceCard = useAppStore(state => state.selectedServiceCard);
  const contentToUse = headlines[step - 1];
  const {
    title,
    lead,
    back
  } = contentToUse || {};

  // Dynamischer back-Text wenn Zubehör gewählt wurde
  const backText = selectedServiceCard === SERVICE_CARD.ZUBEHOER && step === 3
    ? 'Zurück zur WerkstattService Auswahl'
    : back;

  const hasBack = backText && step > 0;

  if (!title && !lead) {
    return null;
  }

  const handleBack = (): void => {
    if (step === maxSteps && reset) {
      reset();
    } else if (selectedServiceCard === SERVICE_CARD.ZUBEHOER && step === 3) {
      setStep(1);
    } else {
      setStep(step - 1);
    }

    scrollToRef();
  };

  return (
    <div className={classNames('headlines', {
      'no-back': !hasBack
    })}>
      {hasBack && (
        <span className="headlines-back" onClick={handleBack}>
          <Icon icon="chevron-left" />
          {backText}
        </span>
      )}
      {title && <h1>{title}</h1>}
      {lead && <p>{lead}</p>}
    </div>
  );
};

export default Headlines;
